import React, { useState } from 'react';
import './Auth.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import "react-toastify/dist/ReactToastify.css";
import { resetPassword } from '../../Services/Services';
import { ClipLoader } from 'react-spinners';

const Resetpassword = () => {
  const [token, setToken] = useState();
  const [newPassword, setNewPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

  const handleOtpsend = async (e) => {
    e.preventDefault();
    setLoading(true);

    toast.dismiss();
    if (!passwordRegex.test(newPassword)) {
      toast.error('Invalid password', { autoClose: 3000 });
      return;
    }
    try {
      const response = await resetPassword(token, newPassword);
      if (response?.status === 200) {
        toast.success("New Password updated successfully");
        navigate("/login");
      } else {
        toast.success(response?.data?.message);
      }

    } catch (error) {
      toast.dismiss();
      if (error?.response?.status === 503) {
        toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
      } else {
        toast.error(error.response?.data?.message || 'Network error. Please check your connection and try again.');
      }
    }
    finally {
      setLoading(false);

    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className='main-login-container'>
      <div className="login-container">
        <div className="login-form">
          <h2>Create a New Password</h2>
          <form onSubmit={handleOtpsend}>
            <div className="password-input-container">
              <input
                type="text"
                placeholder="OTP"
                value={token}
                onChange={(e) => setToken(e.target.value)}
              />
            </div>
            <div className="password-input-container">
              <input
                type={passwordVisible ? "text" : "password"}
                placeholder="Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span
                className="password-toggle-icon"
                onClick={togglePasswordVisibility}
                style={{ position: 'absolute', right: '10px', top: '12px', cursor: 'pointer' }}
              >
                {passwordVisible ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>
            <button type="submit" className='submit-button'>
              {loading ? <ClipLoader color="#fff" loading={loading} size={30} /> : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Resetpassword;
